import React from 'react'
import cn from 'classnames'
import { makeStyles } from '@material-ui/core'
import { styles } from './styles'
const useStyles = makeStyles(() => styles)

export const GenericButton = ({
  onClick = () => {},
  label = '',
  href = '',
  variant = 'primary',
  customStyles = {},
  disabled = false,
  cypress_id,
}) => {
  const classes = useStyles()
  const isPrimary = variant === 'primary'
  const isSecondary = variant === 'secondary'
  const isSecondaryBlack = variant === 'secondary-black'

  return !href ? (
    <div
      style={customStyles}
      className={cn(classes.button, {
        [classes.primary]: isPrimary,
        [classes.secondary]: isSecondary,
        [classes.secondaryBlack]: isSecondaryBlack,
        [classes.disabled]: disabled,
      })}
      onClick={!disabled ? onClick : () => {}}
      cypress_id={cypress_id}
    >
      {label}
    </div>
  ) : (
    <a
      href={href}
      rel="noopener noreferrer"
      style={customStyles}
      className={cn(classes.button, {
        [classes.primary]: isPrimary,
        [classes.secondary]: isSecondary,
        [classes.secondaryBlack]: isSecondaryBlack,
        [classes.disabled]: disabled,
      })}
      cypress_id={cypress_id}
    >
      {label}
    </a>
  )
}
